import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Text, SvgIcon, Image } from 'Components/Base';

import { HealthCheckModal } from '../../../Routes/HealthCheck';

import SideMenuView from './SideMenu.view';

const SidebarFlat = ({
  name,
  logoPath,
  title,
  phoneNo,
  phoneHref,
  appVersion,
  isLogin,
  providerName,
  isOpenExtLink,
  ...props
}) => {
  const avatarText = name ? name.substring(0, 1).toUpperCase() : null;
  const { t } = useTranslation('menu');
  const logoPaths = typeof logoPath === 'string' ? [logoPath] : logoPath;
  const dataTestIdPrefix = 'sidebar-mycourse';

  return (
    <SideMenuView
      name="sidebar-mycourse"
      title={t('HEADER', { name })}
      avatarText={avatarText}
      header={isLogin}
      headerContent={
        <Flex mr={3}>
          <Flex alignItems="center" mr={3}>
            {logoPaths?.map((logo, index) => {
              return (
                <Image
                  mr={index === 0 ? 1 : 0}
                  key={`${providerName}:${logo}`}
                  srcSet={`/assets/images/${logo}-1x.png 1x, /assets/images/${logo}-2x.png 2x, /assets/images/${logo}-3x.png 3x,`}
                  src={`/assets/images/${logo}.png`}
                  alt={title}
                  width={'24px'}
                  height={'24px'}
                />
              );
            })}
          </Flex>

          <Text textStyle={'body2'} data-testid={`text-${dataTestIdPrefix}-login-with`}>
            {t('USER_PROVIDER', { providerName: title })}
          </Text>
        </Flex>
      }
      footer={
        isOpenExtLink && (
          <Flex px={6} mb={5}>
            <SvgIcon size={16} icon={SvgIcon.ICON_LIST.PHONE} />
            <Text textStyle={'body2'} ml={5} data-testid={`text-${dataTestIdPrefix}-footer`}>
              {phoneNo ? (
                <Fragment>
                  {t('FOOTER.OE.LINE_1')}
                  <Text
                    textStyle={'body2'}
                    color={'primary'}
                    ml={1}
                    as={'a'}
                    href={`tel:${phoneHref}`}
                    style={{ display: 'inline', whiteSpace: 'nowrap' }}
                    data-testid={`text-${dataTestIdPrefix}-phone-no`}
                  >
                    {phoneNo}
                  </Text>
                  <br />
                  {t('FOOTER.OE.LINE_2')}
                </Fragment>
              ) : (
                <Fragment>{t('FOOTER.LE')}</Fragment>
              )}
              <Fragment>
                <HealthCheckModal
                  toggleComponent={
                    <Text
                      textStyle={'body2'}
                      mt={2}
                      data-testid={`text-${dataTestIdPrefix}-app-version`}
                    >
                      {t('FOOTER.APP_VERSION', { appVersion: appVersion })}
                    </Text>
                  }
                />
              </Fragment>
            </Text>
          </Flex>
        )
      }
      {...props}
    />
  );
};

export default SidebarFlat;
